const BatteryCapacity_Icon = () => {
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="26" height="26" rx="13" fill="#F2F8F6" />
      <path
        d="M17.5 17.5H7.375C7.07663 17.5 6.79048 17.3815 6.5795 17.1705C6.36853 16.9595 6.25 16.6734 6.25 16.375V9.625C6.25 9.32663 6.36853 9.04048 6.5795 8.82951C6.79048 8.61853 7.07663 8.5 7.375 8.5H17.5C17.7984 8.5 18.0845 8.61853 18.2955 8.82951C18.5065 9.04048 18.625 9.32663 18.625 9.625V10.1875H19.1875C19.4859 10.1875 19.772 10.306 19.983 10.517C20.194 10.728 20.3125 11.0141 20.3125 11.3125V14.6875C20.3125 14.9859 20.194 15.272 19.983 15.483C19.772 15.694 19.4859 15.8125 19.1875 15.8125H18.625V16.375C18.625 16.6734 18.5065 16.9595 18.2955 17.1705C18.0845 17.3815 17.7984 17.5 17.5 17.5ZM7.375 9.625V16.375H17.5V14.6875H19.1875V11.3125H17.5V9.625H7.375Z"
        fill="#79C8B0"
      />
      <path
        d="M17.5 17.5H7.375C7.07663 17.5 6.79048 17.3815 6.5795 17.1705C6.36853 16.9595 6.25 16.6734 6.25 16.375V9.625C6.25 9.32663 6.36853 9.04048 6.5795 8.82951C6.79048 8.61853 7.07663 8.5 7.375 8.5H17.5C17.7984 8.5 18.0845 8.61853 18.2955 8.82951C18.5065 9.04048 18.625 9.32663 18.625 9.625V10.1875H19.1875C19.4859 10.1875 19.772 10.306 19.983 10.517C20.194 10.728 20.3125 11.0141 20.3125 11.3125V14.6875C20.3125 14.9859 20.194 15.272 19.983 15.483C19.772 15.694 19.4859 15.8125 19.1875 15.8125H18.625V16.375C18.625 16.6734 18.5065 16.9595 18.2955 17.1705C18.0845 17.3815 17.7984 17.5 17.5 17.5ZM7.375 9.625V16.375H17.5V14.6875H19.1875V11.3125H17.5V9.625H7.375Z"
        fill="url(#paint0_linear_1930_3102)"
      />
      <path d="M16.375 10.75V15.25H8.5V10.75H16.375Z" fill="#79C8B0" />
      <path
        d="M16.375 10.75V15.25H8.5V10.75H16.375Z"
        fill="url(#paint1_linear_1930_3102)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1930_3102"
          x1="17.6758"
          y1="16"
          x2="12.821"
          y2="8.81077"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_1930_3102"
          x1="9.8125"
          y1="14.4063"
          x2="11.8897"
          y2="10.5709"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#1FA37C" />
          <stop offset="1" stop-color="#1FA37C" stop-opacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default BatteryCapacity_Icon;
